<template>
  <dialog-base
    :visible.sync="visible"
    title="Thêm khoản thu học sinh hàng loạt"
    size="lg"
    :use-panel="false"
    top="6vh"
    @cancel="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-width="170px"
      label-position="left"
      class="sk-dialog-content"
    >
      <!-- ══════════════════════════════════════════
           PHÂN KHU 1 – THÔNG TIN PHẠM VI ÁP DỤNG (read-only)
           ══════════════════════════════════════════ -->
      <div class="sk-panel mb-4">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-office-building" /></div>
          <div>
            <p class="sk-panel-title">Phạm vi áp dụng khoản thu</p>
            <p class="sk-panel-subtitle">Chi tiết phạm vi áp dụng khoản thu (không thể chỉnh sửa)</p>
          </div>
        </div>

        <div class="abrd-scope-container">
          <div class="abrd-scope-item">
            <span class="abrd-scope-label">Đối tượng:</span>
            <span class="abrd-scope-value">{{ scopeData.targetName || "—" }}</span>
          </div>
          <div class="abrd-scope-item">
            <span class="abrd-scope-label">Tháng - Năm:</span>
            <span class="abrd-scope-value" v-if="scopeData.month && scopeData.year">Tháng {{ scopeData.month }}/{{ scopeData.year }}</span>
            <span class="abrd-scope-value" v-else>—</span>
          </div>
          <div class="abrd-scope-item">
            <span class="abrd-scope-label">Đợt thu:</span>
            <span class="abrd-scope-value">Đợt {{ scopeData.turn || 1 }}</span>
          </div>
          <div class="abrd-scope-item">
            <span class="abrd-scope-label">Số phiếu đang hiển thị:</span>
            <span class="abrd-scope-value">{{ scopeData.invoiceCount || 0 }} phiếu thu</span>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════
           PHÂN KHU 2 – THÔNG TIN KHOẢN THU (editable)
           ══════════════════════════════════════════ -->
      <div class="sk-panel mb-4">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-circle-plus-outline" /></div>
          <div>
            <p class="sk-panel-title">Chi tiết khoản thu mới</p>
            <p class="sk-panel-subtitle">Thiết lập tên khoản thu, đơn giá, số lượng, giảm giá và mô tả</p>
          </div>
        </div>

        <el-row :gutter="20">
          <!-- Tên khoản thu -->
          <el-col :span="12">
            <el-form-item label="Tên khoản thu" prop="revenueName">
              <el-input v-model="dataForm.revenueName" placeholder="Nhập tên khoản thu" clearable />
            </el-form-item>
          </el-col>

          <!-- Đơn vị tính -->
          <el-col :span="12">
            <el-form-item label="Đơn vị tính" prop="unit">
              <el-select
                v-model="dataForm.unit"
                filterable
                allow-create
                default-first-option
                placeholder="Chọn hoặc nhập đơn vị"
                style="width: 100%;"
              >
                <el-option v-for="u in unitsList" :key="u" :label="u" :value="u" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Đơn giá -->
          <el-col :span="12">
            <el-form-item label="Đơn giá (VNĐ)" prop="price">
              <el-currency-input
                v-model="dataForm.price"
                :options="currencyOptions"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <!-- Số lượng -->
          <el-col :span="12">
            <el-form-item label="Số lượng" prop="quantity">
              <el-input
                v-model.number="dataForm.quantity"
                type="number"
                :step="allowDecimal ? 0.01 : 1"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <!-- Cho phép số thập phân -->
          <el-col :span="12">
            <el-form-item label="Cho phép số thập phân">
              <el-switch
                v-model="allowDecimal"
                active-text="Có"
                inactive-text="Không"
              />
            </el-form-item>
          </el-col>

          <!-- Giảm giá Có / Không -->
          <el-col :span="12">
            <el-form-item label="Giảm giá" prop="discount">
              <el-radio-group v-model="dataForm.discount" @change="handleDiscountToggle">
                <el-radio :label="true">Có</el-radio>
                <el-radio :label="false">Không</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!-- Thành tiền -->
          <el-col :span="12">
            <el-form-item label="Thành tiền (VNĐ)" prop="amount">
              <el-currency-input
                v-model="displayAmount"
                :options="currencyOptions"
                disabled
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <!-- Thuế suất -->
          <el-col :span="12">
            <el-form-item label="Thuế suất" prop="taxPercentage">
              <el-select
                v-model="dataForm.taxPercentage"
                placeholder="Chọn thuế suất"
                clearable
                style="width: 100%;"
                @change="handleTaxChange"
              >
                <el-option label="Không chịu thuế" :value="-2" />
                <el-option label="Không kê khai" :value="-1" />
                <el-option label="0%" :value="0" />
                <el-option label="5%" :value="5" />
                <el-option label="8%" :value="8" />
                <el-option label="10%" :value="10" />
                <el-option label="Khác" value="other" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Thuế khác (%) nếu chọn Khác -->
          <el-col :span="12" v-if="String(dataForm.taxPercentage) === 'other'">
            <el-form-item label="Thuế khác (%)" prop="taxPercentageInput">
              <el-input-number
                v-model="dataForm.taxPercentageInput"
                :controls="false"
                :min="0"
                :max="100"
                style="width: 100%;"
                placeholder="Nhập % thuế"
              />
            </el-form-item>
          </el-col>

          <!-- Loại giảm giá -->
          <el-col :span="12" v-if="dataForm.discount">
            <el-form-item label="Loại giảm giá" prop="discountType">
              <el-select
                v-model="dataForm.discountType"
                placeholder="Chọn loại giảm giá"
                style="width: 100%;"
                @change="handleDiscountTypeChange"
              >
                <el-option label="Phần trăm (%)" value="PERCENT" />
                <el-option label="Số tiền (VNĐ)" value="MONEY" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Giá trị giảm -->
          <el-col :span="12" v-if="dataForm.discount">
            <el-form-item prop="discountValue">
              <template v-slot:label>
                <span v-if="dataForm.discountType === 'PERCENT'">Phần trăm giảm (%)</span>
                <span v-else>Số tiền giảm (VNĐ)</span>
              </template>
              <div class="edit-discount-container">
                <div class="edit-discount-input">
                  <template v-if="dataForm.discountType === 'MONEY'">
                    <el-currency-input
                      v-model="dataForm.discountValue"
                      :options="currencyOptions"
                      style="width: 100%;"
                    />
                  </template>
                  <template v-else>
                    <el-input-number v-discount-percent
                      v-model="dataForm.discountValue"
                      :min="0"
                      :max="100"
                      :precision="0"
                      controls-position="right"
                      style="width: 100%;"
                    />
                  </template>
                </div>
                <div v-if="discountAmount > 0" class="erd-discount-amount">
                  -{{ formatMoney(discountAmount) }}
                </div>
              </div>
            </el-form-item>
          </el-col>

          <!-- Mô tả -->
          <el-col :span="24">
            <el-form-item label="Mô tả" prop="description">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="Nhập mô tả..."
                v-model="dataForm.description"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- ══════════════════════════════════════════
           PHÂN KHU 3 – HÓA ĐƠN ĐIỆN TỬ
           ══════════════════════════════════════════ -->
      <div class="sk-panel mb-4">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--warning"><i class="el-icon-tickets" /></div>
          <div>
            <p class="sk-panel-title">Hóa đơn điện tử</p>
            <p class="sk-panel-subtitle">Cấu hình xuất hóa đơn điện tử cho khoản thu này</p>
          </div>
        </div>

        <el-form-item label="Xuất hóa đơn điện tử" prop="issuingElectronicInvoices">
          <el-radio-group v-model="dataForm.issuingElectronicInvoices">
            <el-radio :label="true">Có</el-radio>
            <el-radio :label="false">Không</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <!-- Khối lưu ý / Cảnh báo -->
      <div class="sk-note sk-note--warning mb-4">
        <i class="el-icon-warning-outline" />
        <span>
          Khoản thu mới sẽ được bổ sung vào các phiếu thu đã khởi tạo của {{ scopeData.targetType === 'GROUP' ? 'nhóm' : 'lớp' }} <strong>{{ scopeData.targetName }}</strong> trong tháng <strong>{{ scopeData.month }}</strong> đợt <strong>{{ scopeData.turn }}</strong>. Phiếu “Chưa đóng 100%” nhận số lượng theo form và tính lại tiền; các trạng thái khác nhận số lượng và thành tiền bằng 0.
        </span>
      </div>
    </el-form>

    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" type="danger" plain @click="handleClose">Hủy</el-button>
        <el-button
          class="btn-save"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
        >
          <i class="el-icon-plus" /> Thêm khoản thu
        </el-button>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import { discountPercentInput, hasOverLimitPercentDiscount, DISCOUNT_PERCENT_LIMIT_MESSAGE } from "@/utils/discountPercent";
import DialogBase from "@/components/DialogBase.vue";
import ElCurrencyInput from "@/components/ElCurrencyInput.vue";
import { DEFAULT_UNITS } from "@/constant/tuitionConstant";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

function initDataForm() {
  return {
    revenueName: "",
    unit: "Tháng",
    price: 0,
    quantity: 1,
    taxPercentage: null,
    taxPercentageInput: null,
    discount: false,
    discountType: "MONEY",
    discountValue: 0,
    amount: 0,
    description: "",
    issuingElectronicInvoices: false,
  };
}

export default {
  directives: { discountPercent: discountPercentInput },
  name: "AddBatchRevenueDialog",
  components: {
    DialogBase,
    ElCurrencyInput,
  },
  data() {
    const validateQuantity = (rule, value, callback) => {
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập số lượng"));
      }
      const num = Number(value);
      if (isNaN(num) || num < 0) {
        return callback(new Error("Số lượng phải >= 0"));
      }
      if (!this.allowDecimal && !Number.isInteger(num)) {
        return callback(new Error("Số lượng phải là số nguyên khi chưa bật số thập phân"));
      }
      callback();
    };

    const validateDiscountType = (rule, value, callback) => {
      if (this.dataForm.discount && !value) {
        return callback(new Error("Vui lòng chọn loại giảm giá"));
      }
      callback();
    };

    const validateDiscountValue = (rule, value, callback) => {
      if (!this.dataForm.discount) return callback();
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập giá trị giảm"));
      }
      const num = Number(value);
      if (isNaN(num) || num < 0) {
        return callback(new Error("Giá trị giảm phải >= 0"));
      }
      if (this.dataForm.discountType === "PERCENT" && num > 100) {
        return callback(new Error("Phần trăm giảm không được vượt quá 100%"));
      }
      const rawTotal = (Number(this.dataForm.price) || 0) * (Number(this.dataForm.quantity) || 0);
      if (this.dataForm.discountType === "MONEY" && num > rawTotal) {
        return callback(new Error("Số tiền giảm không được vượt quá thành tiền trước giảm"));
      }
      callback();
    };

    const validateTaxPercentageInput = (rule, value, callback) => {
      if (String(this.dataForm.taxPercentage) !== "other") return callback();
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập thuế suất (%)"));
      }
      const num = Number(value);
      if (isNaN(num) || num < 0 || num > 100) {
        return callback(new Error("Thuế suất phải từ 0 đến 100%"));
      }
      callback();
    };

    return {
      visible: false,
      loading: false,
      allowDecimal: false,
      unitsList: [...DEFAULT_UNITS],
      currencyOptions: {
        currency: "VND",
        locale: "vi",
        precision: 0,
        allowNegative: false,
      },
      scopeData: {
        targetId: null,
        targetType: "CLASS",
        targetName: "",
        month: "",
        year: "",
        turn: 1,
        invoiceCount: 0,
      },
      dataForm: initDataForm(),
      formRules: {
        revenueName: [
          { required: true, message: "Vui lòng nhập tên khoản thu", trigger: "blur" },
          { min: 2, max: 150, message: "Độ dài từ 2 đến 150 ký tự", trigger: "blur" },
        ],
        unit: [
          { required: true, message: "Vui lòng chọn hoặc nhập đơn vị tính", trigger: "change" },
        ],
        price: [
          { required: true, message: "Vui lòng nhập đơn giá", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "Vui lòng nhập số lượng", trigger: "blur" },
          { validator: validateQuantity, trigger: ["blur", "change"] },
        ],
        discountType: [{ validator: validateDiscountType, trigger: "change" }],
        discountValue: [{ validator: validateDiscountValue, trigger: "blur" }],
        taxPercentageInput: [{ validator: validateTaxPercentageInput, trigger: ["blur", "change"] }],
      },
    };
  },
  computed: {
    discountAmount() {
      if (!this.dataForm.discount) return 0;
      const price = Number(this.dataForm.price) || 0;
      const quantity = Number(this.dataForm.quantity) || 0;
      const val = Number(this.dataForm.discountValue) || 0;
      if (this.dataForm.discountType === "PERCENT") {
        return Math.round((price * quantity * val) / 100);
      }
      return val;
    },

    effectiveTaxRate() {
      if (String(this.dataForm.taxPercentage) === "other") {
        return Number(this.dataForm.taxPercentageInput) || 0;
      }
      const tax = Number(this.dataForm.taxPercentage);
      return tax > 0 ? tax : 0;
    },

    calculatedAmount() {
      const price = Number(this.dataForm.price) || 0;
      const quantity = Number(this.dataForm.quantity) || 0;
      const amountBeforeTax = price * quantity - this.discountAmount;
      if (this.effectiveTaxRate > 0) {
        return Math.max(0, Math.round(amountBeforeTax * (1 + this.effectiveTaxRate / 100)));
      }
      return Math.max(0, amountBeforeTax);
    },

    displayAmount: {
      get() {
        return this.calculatedAmount;
      },
      set(val) {
        this.dataForm.amount = val;
      },
    },
  },
  watch: {
    "dataForm.unit"(val) {
      if (val && !this.unitsList.includes(val)) {
        this.unitsList.push(val);
      }
    },
  },
  methods: {
    /**
     * Mở dialog thêm khoản thu học sinh hàng loạt
     * @param {Object} scope - Thông tin ngữ cảnh phạm vi (targetId, targetType, targetName, month, year, turn, invoiceCount)
     */
    open(scope = {}) {
      this.visible = true;
      this.loading = false;
      this.allowDecimal = false;
      this.dataForm = initDataForm();

      this.scopeData = {
        targetId: scope.targetId || null,
        targetType: scope.targetType || "CLASS",
        targetName: scope.targetName || "",
        month: scope.month || "",
        year: scope.year || "",
        turn: scope.turn || 1,
        invoiceCount: scope.invoiceCount || 0,
      };

      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });
    },

    handleDiscountToggle(val) {
      if (!val) {
        this.dataForm.discountValue = 0;
      }
      this.$nextTick(() => this.$refs.dataForm?.clearValidate(["discountType", "discountValue"]));
    },

    handleDiscountTypeChange() {
      this.dataForm.discountValue = 0;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate("discountValue"));
    },

    handleTaxChange(val) {
      if (val !== "other") {
        this.dataForm.taxPercentageInput = null;
      }
      this.$nextTick(() => this.$refs.dataForm?.clearValidate(["taxPercentage", "taxPercentageInput"]));
    },

    formatMoney(value) {
      if (value === null || value === undefined || value === "") return "—";
      return Number(value).toLocaleString("vi-VN") + " ₫";
    },

    handleClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.dataForm?.resetFields();
      this.dataForm = initDataForm();
      this.$emit("close");
    },

    handleSubmit() {
      if (this.loading || !this.$refs.dataForm) return;

      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;

        this.loading = true;

        const taxVal = this.dataForm.taxPercentage;
        const resolvedTax =
          taxVal === "other"
            ? Number(this.dataForm.taxPercentageInput) || 0
            : taxVal !== null && taxVal !== "" && taxVal !== undefined
            ? Number(taxVal)
            : null;

        const resultPayload = {
          targetId: this.scopeData.targetId,
          targetType: this.scopeData.targetType,
          month: Number(this.scopeData.month),
          year: Number(this.scopeData.year),
          turn: Number(this.scopeData.turn),
          revenueName: this.dataForm.revenueName.trim(),
          price: Number(this.dataForm.price) || 0,
          unit: this.dataForm.unit || "Tháng",
          quantity: Number(this.dataForm.quantity),
          taxPercentage: resolvedTax,
          discount: !!this.dataForm.discount,
          discountType: this.dataForm.discount ? this.dataForm.discountType : null,
          discountValue: this.dataForm.discount ? Number(this.dataForm.discountValue) || 0 : 0,
          note: this.dataForm.description ? this.dataForm.description.trim() : "",
          issuingElectronicInvoices: !!this.dataForm.issuingElectronicInvoices,
          category: "IN",
        };

        try {
          if (hasOverLimitPercentDiscount(resultPayload)) {
            NotifyMessage.leftCornerNotificationError(DISCOUNT_PERCENT_LIMIT_MESSAGE);
            return;
          }

          const res = await ManagingStudentInvoiceService.batchAddRevenue(resultPayload);
          const result = res?.data?.data;
          if (!result || typeof result.updatedInvoiceCount !== "number" || !/^[A-Za-z0-9]{15}$/.test(result.revenueCode || "")) {
            throw new Error("API thêm khoản thu không trả kết quả hợp lệ.");
          }
          this.$emit("saved", { ...resultPayload, ...result });
          this.visible = false;
        } catch (error) {
          let errorData = error?.response?.data;
          if (typeof errorData === "string") {
            try { errorData = JSON.parse(errorData); } catch (_) { /* Giữ thông báo gốc. */ }
          }
          const message = errorData?.message || (typeof errorData === "string" ? errorData : null)
            || error?.message || "Không thể thêm khoản thu.";
          NotifyMessage.leftCornerNotificationError(typeof message === "string" ? message : JSON.stringify(message));
          this.$emit("refresh");
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

.abrd-scope-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.abrd-scope-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.abrd-scope-label {
  font-family: Inter, Arial, Helvetica, sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}

.abrd-scope-value {
  font-size: 13.5px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}

/deep/ .el-input.is-disabled .el-input__inner,
/deep/ .el-input.is-disabled input,
/deep/ input:disabled {
  color: #15803d !important;
  -webkit-text-fill-color: #15803d !important;
  font-weight: 600;
}

/deep/ .el-input-number {
  width: 100%;
}

.edit-discount-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}

.edit-discount-input {
  flex: 1;
}

.erd-discount-amount {
  color: #dc2626;
  font-weight: 700;
  white-space: nowrap;
}
</style>
